import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { setMasqueradeCompanyId } from 'shared/graphql/masquerade'

/**
 * Enter a company (masquerade) and navigate, for the corporate location surfaces — the locations
 * table, the locations map, and the dashboard's location list.
 *
 * Exists so those surfaces share one implementation instead of each poking storage directly, and so
 * `GoogleMapsComponent` (in `@paintscout/ui-business`, which can't reach the app's masquerade helper)
 * can take it as a prop. `setMasqueradeCompanyId` announces the change, so the app re-scopes itself
 * whether or not `url` actually changes the current route.
 */
export function useMasqueradeToLocation(): (companyId: string, url: string) => void {
  const history = useHistory()

  return useCallback(
    (companyId: string, url: string) => {
      setMasqueradeCompanyId(companyId)
      history.push(url)
    },
    [history]
  )
}
